module.exports = __webpack_public_path__ + "img/cse_image.30209aa2.jpg";